import { Helmet } from '@dr.pogodin/react-helmet';
import NoticeSiteHasBeenArchived from '../common/lib/NoticeSiteHasBeenArchived';
import type { MultiLang } from '../config';
import Functions from '../functions';
import './assets/xwords.css';
import XwordsBreadcrumbs from './lib/XwordsBreadcrumbs';
import XwordsCategoryFieldset from './lib/XwordsCategoryFieldset';
import XwordsInitialFieldset from './lib/XwordsInitialFieldset';
import XwordsRandomFieldset from './lib/XwordsRandomFieldset';
import XwordsRankingFieldset from './lib/XwordsRankingFieldset';
import XwordsRecentlyFieldset from './lib/XwordsRecentlyFieldset';
import XwordsSearchFieldset from './lib/XwordsSearchFieldset';
import XwordsUtils from './lib/XwordsUtils';

interface Props {
    lang: MultiLang;
}

const XwordsIndex = (props: Props) => {
    const { lang } = props;
    const name = XwordsUtils.getName();
    const mtitle = Functions.mlang(name, lang);
    return (
        <div className="xwords">
            <Helmet>
                <title>
                    {mtitle} - {Functions.siteTitle(lang)}
                </title>
            </Helmet>
            <h3>{mtitle}</h3>
            <NoticeSiteHasBeenArchived lang={lang} />
            <XwordsBreadcrumbs lang={lang} />
            <div className="row">
                <XwordsCategoryFieldset lang={lang} />
            </div>
            <div className="row">
                <XwordsInitialFieldset lang={lang} catId={0} />
            </div>
            <div className="row three">
                <XwordsRecentlyFieldset lang={lang} catId={0} />
                <XwordsRankingFieldset lang={lang} catId={0} />
                <XwordsRandomFieldset lang={lang} />
            </div>
            <div className="row">
                <XwordsSearchFieldset lang={lang} type={4} catId={0} andor="OR" term="" />
            </div>
        </div>
    );
};

export default XwordsIndex;
